import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { getFyNumber } from '../../utils/calculation';

const currencyArray = (state: RootState) => state.currency.currency;
const loading = (state: RootState) => state.currency.loading;
const fy = (state: RootState) => state.currency.selectedFy;

const selectCurrencyArray = createDraftSafeSelector(
  currencyArray,
  (currencyArray) => currencyArray || {},
);

const selectReverseCurrencyArray = createDraftSafeSelector(
  currencyArray,
  (currencyArray) => {
    return Object.keys(currencyArray).reduce((acc, key) => {
      const accCopy = { ...acc };
      const fiscalYear = currencyArray[key];
      fiscalYear.forEach((currency) => {
        if (!accCopy[currency.countryId])
          accCopy[currency.countryId] = {
            currencyCode: currency.currencyCode,
          };
        accCopy[currency.countryId][key] = currency.currencyRate;
      });
      return accCopy;
    }, {});
  },
);

const selectCurrencyFactorsLoading = createDraftSafeSelector(
  [selectCurrencyArray, loading],
  (factors, loading) => !factors && loading,
);

const selectSelectedFy = createDraftSafeSelector(fy, (fy) => fy);

const selectCurrencyFys = createDraftSafeSelector(
  selectCurrencyArray,
  (factors) =>
    (factors &&
      Object.keys(factors)?.sort((a, b) => getFyNumber(b) - getFyNumber(a))) ||
    [],
);

const selectSelectedCurrency = createDraftSafeSelector(
  [selectSelectedFy, selectCurrencyArray],
  (fy, factors) =>
    (factors &&
      factors[fy] &&
      [...factors[fy]].sort((a, b) => parseInt(a.id) - parseInt(b.id))) ||
    [],
);

const selectLatestCurrency = createDraftSafeSelector(
  [selectCurrencyArray, selectCurrencyFys],
  (factors, fys) => factors[fys[0]] || [],
);

export {
  currencyArray,
  selectCurrencyFactorsLoading,
  selectCurrencyArray,
  selectSelectedFy,
  selectCurrencyFys,
  selectSelectedCurrency,
  selectLatestCurrency,
  selectReverseCurrencyArray,
};
